import React, { ReactNode } from "react";
import { SubHeader } from "src/components";
import { RootState } from "src/context/store";
import { useSelector } from "react-redux";
import OrderBulkUpload from "src/features/fields/pages/PurchaseOrder/OrderTypeException/order-type-exp-bulk-upload/order-bulk-upload";

interface CounterLayoutProps {
  children: ReactNode;
}

const InvoiceLayout: React.FC<CounterLayoutProps> = ({ children }) => {
  const showBulkUploadModal = useSelector((state: RootState) => state.po.bulkUploadModalState);
  return (
    <div className="w-full">
      <div className="flex">
        <SubHeader />
      </div>

      {children}

      {showBulkUploadModal?.orderTypeExcBulk && <OrderBulkUpload />}
    </div>
  );
};

export default InvoiceLayout;
